
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faq4rLxVsM4S_S51ocqLN8L3PNsZ6ytmo7SFiS5KgbrrAsMeta } from "/codebuild/output/src3102319033/src/src/pages/faq.vue?macro=true";
import { default as menuvR1bo_iKemurkHP8lix5aoQS8fhqwTSXk2beWdGmz6EMeta } from "/codebuild/output/src3102319033/src/src/pages/menu.vue?macro=true";
import { default as indexAaHZ9iXwY44D0mXA0rnRE3IUSWhwOr6x6lxsLsP8vDsMeta } from "/codebuild/output/src3102319033/src/src/pages/index.vue?macro=true";
import { default as contactn7byQ2Xxu1Y0k676lId3KITuYVnbr_45psgF6efXWJxFQMeta } from "/codebuild/output/src3102319033/src/src/pages/contact.vue?macro=true";
import { default as tutorialh49hWYzMs4l9FjAPNyU_45WR_L3L7k8lPgXvfgDXowXBYMeta } from "/codebuild/output/src3102319033/src/src/pages/tutorial.vue?macro=true";
import { default as agreementXr8Zw5IXOWPYMWns4wbme90cPk903GbWfQDGOT2EUbwMeta } from "/codebuild/output/src3102319033/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass48emBFJv_45ORjZ9a6TszoPP7iaQEFbN7aiYlpIJlKu5QMeta } from "/codebuild/output/src3102319033/src/src/pages/about-pass.vue?macro=true";
import { default as indexrc8yqtLxjQo5HGYAnFPdAKUBdaX5c0lZYdOOF5nZis0Meta } from "/codebuild/output/src3102319033/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Kiy3p8NWplXg9EYYwPOv_BaRyGZCmh_45Dlo72X80wGIYMeta } from "/codebuild/output/src3102319033/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance1hcMVNMis16ngGiMLZie6L4HyZcRELt2loMSz4BODKwMeta } from "/codebuild/output/src3102319033/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93QddqN1u3uZO7NAoWRFs_45_kdnBx8sqON9SUdAPLpijXwMeta } from "/codebuild/output/src3102319033/src/src/pages/notice/[id].vue?macro=true";
import { default as indexRJfsCYF3Zs30dpXT42bOT5TDi17IwpFWz7lJtVjW154Meta } from "/codebuild/output/src3102319033/src/src/pages/coupon/index.vue?macro=true";
import { default as indexHcKrn6w_rleRXsy1U2BPCSgI3VIQMYUx3Qzk0haVN2UMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/index.vue?macro=true";
import { default as index_4531YMYyyy1b_ciEY2ohT0vEoae93Juflkh0eX2A_45NLkMeta } from "/codebuild/output/src3102319033/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93FaEfwr9oW4bVg13JuUnqrZxVtu8CbOEi_3hENGtT8pEMeta } from "/codebuild/output/src3102319033/src/src/pages/parking/[id].vue?macro=true";
import { default as indexfl9erkPc7TNhVBz_45qMyQ1B0C5tV7Y4G5BRC_45iqeBKpEMeta } from "/codebuild/output/src3102319033/src/src/pages/history/index.vue?macro=true";
import { default as indextw12eJ0GcUjFLvH0SdPrmIdRBJUd6JWmjSPCVE9AZVkMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/index.vue?macro=true";
import { default as indexOzQ0JsYYTINK7ApPJVCHGMk_45UjM0_45JkpHbW3WxK5CzoMeta } from "/codebuild/output/src3102319033/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexVN9UJNIHj2H5fysiYhMPx_Oaa_UIKOZvPtoVeA8S37EMeta } from "/codebuild/output/src3102319033/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviB4quevW_mv9hJUo8ck9KOe89c82KmeqU6h6nU_45PU4WkMeta } from "/codebuild/output/src3102319033/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit1kLbunIRvrFVEeywEOCAqXGn_45DGvmtzGGYo_45MHRgTm0Meta } from "/codebuild/output/src3102319033/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementnnzD5CPVee0Q0bsKchF1wUeEaC_BD0xddPb7Sh50K38Meta } from "/codebuild/output/src3102319033/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexA4mC9LgTGAPOMEgltZe2VQ7VT9vYj7eFqqO5VMEw5u0Meta } from "/codebuild/output/src3102319033/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dILTKJAK6dYxOEl0TAgbmBaUW6Kx4OMZByd62X5mcYvEMeta } from "/codebuild/output/src3102319033/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm2tOoXwKXtHfewqcNpnuKm16S5OpF_blkX_45P4pvjefoEMeta } from "/codebuild/output/src3102319033/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexFCJtz_7Ev3GxET8jfQoyJyz753R4XZm6DC4VinSm1RwMeta } from "/codebuild/output/src3102319033/src/src/pages/card/create/index.vue?macro=true";
import { default as indexNHrpdRxS1SkKFaPQYk8acQM8OjOioBqyQz11U_45Kt_D0Meta } from "/codebuild/output/src3102319033/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmKJ1XoFXKx5wSIki0l4ZW_45gSO90ou_45ybqO3SJzGGnwGkMeta } from "/codebuild/output/src3102319033/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmiMDsA3iLum1EPWvB6DPPTwyhIiKHEjUbkqy7Ez17xbUMeta } from "/codebuild/output/src3102319033/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completedkOtnvMJ_fDWIXOeo1pQRW92wIELAKBasElA_453_45vgAsMeta } from "/codebuild/output/src3102319033/src/src/pages/membership/complete.vue?macro=true";
import { default as registerlMgcqwZmFaR9itkD8Zdr63ee24XCsHdVhWTEc64uAmAMeta } from "/codebuild/output/src3102319033/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93JRpzutLc8PDaCGYCL9ZfDea4k_Z0ulegoqVMhixXb6EMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmxJ1RarBDn_45mL7p3J4jHSRXY4AG9eCXdUc0jM9fVV1IgMeta } from "/codebuild/output/src3102319033/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93RYbv1n_45Bhb0Gq3HsmGGBWY_45202gbFpY6WeDPm425wY8Meta } from "/codebuild/output/src3102319033/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexKade5b72KC4N0whopzNyck8T3xTy6a1bGUeNz1TVrSAMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeQ_PfQMcgrPB00UxXE5hePgbYKyBkGygbk3Z2XPrDdcUMeta } from "/codebuild/output/src3102319033/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code6ELZATzO_45n_458yoq_OMVPdaHe_45_VqgNOGdwlppEbuLlMMeta } from "/codebuild/output/src3102319033/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeNo0AKgYWLtbfXUWm5_45f0X4w8zS4Iv08txGUuwhVNDAwMeta } from "/codebuild/output/src3102319033/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerQXGg1hehEPg8BCij0eD_45Jz7dv79cFY4G9qn50vmk3kMMeta } from "/codebuild/output/src3102319033/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeFd2QsfOvxK_45ng08FIl0E_45XCFM9vPbU9lh1nTZyrvJ2IMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index4WegmFbU2dVftWvLU2_pkFAKusAzfmEqiLwbqeYrHbwMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmLT8_GU_45EnrRyVqBDC52Y01LJGBT_GZdbCIZ3_458wX6AMMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeNwN8zBj3qjsCOolPMqe6uC_1aSQt_S6_wzMX3GUT95oMeta } from "/codebuild/output/src3102319033/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexpgqzlfmTmHqUppPmtDrXmJcCftiFdarElhmezKyblhQMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93HixCKy0sTCjetSTK_bSbWKCZVPrjzxOJWldjl0Dv7ZcMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeYzHAFOJlWSohUYbD8xMBn_tzvMkapKJW4OTz5SKbdpcMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias3VcwE_45ubhh7JItne6dWxGHY_xjqgNa5QyrFEBgaM0f0Meta } from "/codebuild/output/src3102319033/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplefV1rmTZc7Kt4sysOzB_boCiVNHe3SCN4uoqD4_SZpx0Meta } from "/codebuild/output/src3102319033/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailRN4XMn1KOXZISeQH9_eH3scVndJkurVJ52FuTsGw_OwMeta } from "/codebuild/output/src3102319033/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDJl4Vimibo_455QJADM0FqMZsUPXTR_459_45m_45qXBP6wJv_EMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentt1jV4Aah9LPwvYjXnBVvsxUmcYAtEUzA65WET_45HipTkMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmNb_45FTrdrMUdTJ9HodahqTZkIXU2QF8eUPz8ISmW4PM4Meta } from "/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate1IGlQtAiX8r_45TLWCOMhdcX6rmE6J5uuy2BcX8pp_45yuMMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeRdB0JltTztrbYeZ9S4SYxJf2Xd3t8DjD6os9LzbAFMMMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeyeV9srHX_4fvEHZkd10il2hfWibKMKvOUEYqmoahTgoMeta } from "/codebuild/output/src3102319033/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password61jK8yPWOq_45y5OMdRjzfzBP4HazzbuWmUia_45Ogi8tVwMeta } from "/codebuild/output/src3102319033/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliass88BmijdAdJI8N5_45XTh18K1taqqEPG5JU42j_4sWZDQMeta } from "/codebuild/output/src3102319033/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register5uenE0vbsfHnUIBQwd0nRpDn63oGT_wSIzY_45winno_cMeta } from "/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code5dUUcK3suQt4InQd4fXHB3i84LJRLiLCLT_45MPHIkCCkMeta } from "/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexAgWrNFf37R7Stl89M8Qwc7GyLVkdTGF4WC14yVgkqAwMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4cwbkRoKzd79Y2jXoe4YHLd_DqOqduey33f_WIqLU6sMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexAXKsJ9ysuLw_bRO0gktVulTHutn5CnDNMsgPwhypZ7AMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexxm0OiRW5FrYwZr2cSSSjesrkv4xgwbgUbw3DrE_XD3UMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateiK776gqNlInac6xv7pkN5T2gpv1d0wejw7mNCg5_45pIMMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete9mkeX3554tjgSAFutttdxIXfKq_45m1uPvXItj0_45sFZBMMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmZ9ZY0xIHjguWNn5z5y_459Hdtsfh6bfhwJOUdKYf8e8kAMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexCc0H1mecDaNe7jlhOK06JemO8HLJL1k61vZXFMBbVK8Meta } from "/codebuild/output/src3102319033/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeDSDjnzkc1J8_45fNuNc9ix7eiKDTojgxjDogiLEbRPmqkMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatefxfFihQc1KVU_41uQvFYhKpt1Nl3zGrG5LruumYpCz8Meta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexuCKFh_Mq5cmhbTQJd7eUxZ_45Y96yc1SjcFLCjKvA5HPIMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJ7raUOMS2scUiwQu_454i4Cw_45Zd7EcHEVXmU2lC60pZeEMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completecUFgdoGrqs_45AEsOhP7XCcs_sWmPNDZutGMJFutMpfikMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexx0iliLvNnU_3wQfn7hCmiB9GYsGJGrHQ8w_nt2TsnQ4Meta } from "/codebuild/output/src3102319033/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeGwoK_U0tD7ahZBHhv527lPW0YMx3fqNIypxD0CXbArcMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexSvJjZGkks6O77vqfDIWJv8ddgjWaQihvGdgjO_45Ew1G0Meta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexjyAYSLX27CJoqzveMzYZB2nPGy8obRjJQo_45WLJdHpLoMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexYgHy_45WmvN8TED63ahR7w3tdC3VxZjdPoInOk3VsM_ZQMeta } from "/codebuild/output/src3102319033/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateuT9vFq7TOdkSJPMqkJ70IA5yD4kv0KSUFW8o0K79lyAMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm9_6_45gN9nXNssn6nDfEPHzc4di5WazbC1143PQgpl8sQMeta } from "/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuvR1bo_iKemurkHP8lix5aoQS8fhqwTSXk2beWdGmz6EMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexAaHZ9iXwY44D0mXA0rnRE3IUSWhwOr6x6lxsLsP8vDsMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexRJfsCYF3Zs30dpXT42bOT5TDi17IwpFWz7lJtVjW154Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexfl9erkPc7TNhVBz_45qMyQ1B0C5tV7Y4G5BRC_45iqeBKpEMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexOzQ0JsYYTINK7ApPJVCHGMk_45UjM0_45JkpHbW3WxK5CzoMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexVN9UJNIHj2H5fysiYhMPx_Oaa_UIKOZvPtoVeA8S37EMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexFCJtz_7Ev3GxET8jfQoyJyz753R4XZm6DC4VinSm1RwMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmKJ1XoFXKx5wSIki0l4ZW_45gSO90ou_45ybqO3SJzGGnwGkMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmiMDsA3iLum1EPWvB6DPPTwyhIiKHEjUbkqy7Ez17xbUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completedkOtnvMJ_fDWIXOeo1pQRW92wIELAKBasElA_453_45vgAsMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerlMgcqwZmFaR9itkD8Zdr63ee24XCsHdVhWTEc64uAmAMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmxJ1RarBDn_45mL7p3J4jHSRXY4AG9eCXdUc0jM9fVV1IgMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeQ_PfQMcgrPB00UxXE5hePgbYKyBkGygbk3Z2XPrDdcUMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code6ELZATzO_45n_458yoq_OMVPdaHe_45_VqgNOGdwlppEbuLlMMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeNo0AKgYWLtbfXUWm5_45f0X4w8zS4Iv08txGUuwhVNDAwMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerQXGg1hehEPg8BCij0eD_45Jz7dv79cFY4G9qn50vmk3kMMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmLT8_GU_45EnrRyVqBDC52Y01LJGBT_GZdbCIZ3_458wX6AMMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeNwN8zBj3qjsCOolPMqe6uC_1aSQt_S6_wzMX3GUT95oMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexpgqzlfmTmHqUppPmtDrXmJcCftiFdarElhmezKyblhQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeYzHAFOJlWSohUYbD8xMBn_tzvMkapKJW4OTz5SKbdpcMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplefV1rmTZc7Kt4sysOzB_boCiVNHe3SCN4uoqD4_SZpx0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailRN4XMn1KOXZISeQH9_eH3scVndJkurVJ52FuTsGw_OwMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDJl4Vimibo_455QJADM0FqMZsUPXTR_459_45m_45qXBP6wJv_EMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentt1jV4Aah9LPwvYjXnBVvsxUmcYAtEUzA65WET_45HipTkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmNb_45FTrdrMUdTJ9HodahqTZkIXU2QF8eUPz8ISmW4PM4Meta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeRdB0JltTztrbYeZ9S4SYxJf2Xd3t8DjD6os9LzbAFMMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeyeV9srHX_4fvEHZkd10il2hfWibKMKvOUEYqmoahTgoMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password61jK8yPWOq_45y5OMdRjzfzBP4HazzbuWmUia_45Ogi8tVwMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register5uenE0vbsfHnUIBQwd0nRpDn63oGT_wSIzY_45winno_cMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code5dUUcK3suQt4InQd4fXHB3i84LJRLiLCLT_45MPHIkCCkMeta || {},
    component: () => import("/codebuild/output/src3102319033/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3102319033/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]